// extracted by mini-css-extract-plugin
export var lg = "_14-4";
export var md = "_14-3";
export var sm = "_14-2";
export var xs = "_14-1";
export var xxs = "_14-0";